import React, { PureComponent } from 'react';
import { PrimaryButton } from 'appSrc/components/UI';
import ImageCropModalWrapper from 'appSrc/components/ImageUpload/CropModalWrapper';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import Edit from 'appSrc/components/Icons/Edit';
import { FormTextField, FormToggle, FormTextArea } from 'appSrc/components/UI/ReduxForm';
import style from './styles/style.module.css';
import defaultBrandedImage from 'appSrc/assets/img/v2.svg';
import { tdcDomainMatch } from 'appSrc/utils/random';


class QRCodeForm extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            selectedImage: props.initialValues.branded_image,
        };
    }

    cropFinish = ( imageData ) => {
        this.setState( {
            selectedImage: imageData,
        } );
        if( imageData != null ) {
            this.props.changeFieldValue( 'branded_image', imageData );
        }
    }

    submitHandler = ( values ) => {
        var data = { ...values };
        data.branded_image = this.state.selectedImage;
        this.props.onSubmit( data );
    }

    render() {
        const { handleSubmit } = this.props;
        const { nfcURL } = this.props.initialValues;
        const { selectedImage } = this.state;

        return (
            <div>
                <Form className={ style.qrCodeForm }
                onSubmit={ handleSubmit( this.submitHandler ) }>
                    <div className={ style.topLevel }>

                        <div>Branded Image</div>
                        <div className={ style.imageWrapper }>
                            <ImageCropModalWrapper
                            aspectRatio={ '1' }
                            onFinish={ this.cropFinish }>
                                <div>
                                    <img src={ selectedImage || defaultBrandedImage } />
                                    <span className={ style.editWrapper }><Edit style={ { display: 'inline-block' } } /></span>
                                </div>
                            </ImageCropModalWrapper>
                        </div>

                        <div className={ style.detailsWrapper }>
                            <Field
                            id="name"
                            name="name"
                            label="Name"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="description"
                            name="description"
                            component={ FormTextArea }
                            label="Description"
                            fullWidth />

                            { nfcURL && 
                                <Field
                                id="nfcURL"
                                name="nfcURL"
                                label="Landing URL"
                                component={ FormTextField }
                                disabled="true"
                                fullWidth />
                            }

                            <Field
                            id="url"
                            name="url"
                            label="Destination URL"
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id="deactivated"
                            name="deactivated"
                            label="Deactivated"
                            component={ FormToggle }
                            style={ { marginTop: '10px' } }
                            />

                            <PrimaryButton
                            label="Submit"
                            fullWidth
                            type="submit"
                            style={ { marginTop: '45px' } }/>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
}

QRCodeForm.defaultProps = {
    initialValues: {},
};

QRCodeForm = reduxForm( {
    form: 'QRCodeForm',
} )( QRCodeForm );

const mapStateToProps = ( state ) => {
    return { };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'QRCodeForm', field, value ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( QRCodeForm );
